import { lazy, useEffect, useState } from "react";
import { useRoutes } from "react-router-dom";

// routes
import MainRoutes from "./MainRoutes";
import StaffRoutes from "./StaffRoutes";
import LoginRoutes from "./LoginRoutes";

import AuthenticationRoutes from "./AuthenticationRoutes";
import Loadable from "ui-component/Loadable";

// import MinimalLayout from 'layout/MinimalLayout';
const FirstLoadLogin = Loadable(
  lazy(() => import("views/pages/authentication/authentication3/Login3"))
);
const Error = Loadable(lazy(() => import("views/pages/maintenance/Error")));
// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const [Role, setRole] = useState("");
  let role = localStorage.getItem("role");
  useEffect(() => {
    if (role !== null) {
      setRole(role);
    }
  }, [Role]);

  return useRoutes([
    { path: "/", element: <FirstLoadLogin /> },
    { path: "*", element: <Error /> },
    // AuthenticationRoutes,
    LoginRoutes,
    // MainRoutes,
    role === "Staff" ? StaffRoutes : MainRoutes,
  ]);
}
// userRole === "user"
// ? PropertOwnerRoutes
// : userRole === "staff"
// ? StaffRoutes
// :
